//
// Capability.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */

var Capability = {
    UNKNOWN:0,
    ACCESS_ESRI_PREMIUM_SERVICES:1,
    ACCESS_MOBILE_BI:2,
    ACCESS_RECENTS:3,
    ACCESS_SETTINGS:4,
    ACCESS_VISUAL_ANALYTICS:5,
    ACCESS_VISUAL_ANALYTICS_VIEWER:6,
    ADD_SHARE:7,
    ALLOW_WEB_CONTENT:8,
    ADD_COMMENTS:9,
    BROWSE_HDFS:10,
    BUILD_CUSTOM_GRAPH:11,
    CATALOG:12,
    COMMENTS:13,
    CREATE_ACTIVITY:14,
    CREATE_AUDIT_ACTIVITY:15,
    CREATE_COLLECTIONS:16,
    CREATE_EXPLORATION:17,
    CREATE_REPORT:18,
    EMAIL:19,
    EXPORT_DATA:20,
    EXPORT_DETAIL_DATA:21,
    EXPORT_IMAGE:22,
    EXPORT_PDF:23,
    EXPORT_EXCEL:24,
    EXPORT_REPORT:25,
    IMPORT_AND_LOAD_DATA:26,
    INTERPRET_REPORT_VIEWER_NATURAL_LANGUAGE:27,
    INSIGHT_REPORT:28,
    GET_STATE_REPORT_VIEWER_NATURAL_LANGUAGE:29,
    UPDATE_STATE_REPORT_VIEWER_NATURAL_LANGUAGE:30,
    LIMIT_OFFLINE_ACCESS:31,
    MANAGE_CUSTOM_LISTS:32,
    MANAGE_ENVIRONMENT:33,
    MANAGE_FAVORITES:34,
    MANAGE_LASR_SERVER:35,
    MANAGE_MOBILE_DEVICES:36,
    MONITOR_LASR:37,
    PERSONALIZATION:38,
    PREPARE_DATA:39,
    PURGE_MOBILE_REPORT_DATA:40,
    REFRESH_DATA:41,
    RENDER_REPORT_IMAGES:42,
    REPORT_OPERATIONS:43,
    REQUIRE_APPLICATION_PASSCODE:44,
    SUBSCRIBE_TO_REPORT_ALERTS:45,
    TEXT_TEMPLATES:46,
    VAA_TABLE_AUTHORIZATION:47,
    VIEW_COMMENTS:48,
    VIEW_FAVORITES:49,
    VIEW_REPORT:50,
    VIEW_SHARES:51
};
export default Capability;
